import { render, staticRenderFns } from "./counselor-manage.vue?vue&type=template&id=457802b0&"
import script from "./counselor-manage.vue?vue&type=script&lang=js&"
export * from "./counselor-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports